import React, { Fragment } from 'react'
import { withRouter } from "react-router";
import { Link, useHistory } from "react-router-dom";
import filter from 'ramda/src/filter'
import pipe from 'ramda/src/pipe'
import { Table, Button, Input, Space, PageHeader, message } from 'antd'
import {
    CopyOutlined,
    DeleteOutlined,
    EditOutlined,
    UnorderedListOutlined
} from '@ant-design/icons';
import { sdkAndroidAttributes, sdkAndroidAttribute } from 'src/data'
import Services from 'src/services'
import { useRadioButton, useRequest } from 'src/hooks'
import { ConfirmPop } from '../ConfirmPop';
import { mapColumn, compareBy } from 'src/utils';


// import { Android as AndroidNetwork } from '../Network/Android'


export const Android = withRouter(function({title}: any) {
    const [loading, setLoading] = React.useState(false)
    const [version, setVersion] = React.useState<string>('')
    const history = useHistory()
    const editLink = (id: string) => '/sdk_editor/android/' + id

    const onCell = (record: any) => {
        return {
            onClick: (event: any) => {
                history.push(editLink(record.id))
            }
        };
    }
    const addOnCell = (column: any) => ({ ...column, onCell, className: 'ant-table-pointer'})
    const makeColumn = pipe(mapColumn, addOnCell)

    const columns = [
        {
            width: 200,
            ...makeColumn(sdkAndroidAttribute.versionName),
            sorter: {
                compare: compareBy('versionName'),
                multiple: 1,
            },
            ellipsis: true,
        },
        {
            title: '',
            key: 'x',
            width: 140,
            render: (props: any) => {
                return (
                    <Fragment>
                        <Link to={`/network/android?sdk_id=${props?.id}&sdk_version=${props?.versionName}`}>
                            <Button icon={<UnorderedListOutlined />}>广告网络</Button>
                        </Link>
                    </Fragment>
                )
            }
        },
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'id',
        // }, 
        makeColumn(sdkAndroidAttribute.isAndroidX),
        {
            ...addOnCell(sdkAndroidAttribute.enabled),
            render(props: any) {
                let state = (sdkAndroidAttribute.enabled.values as Array<any>).find((enabled: any) => enabled.key === props.enabled.toString())
                if(state.key === '0') {
                    return
                }

                if(props.isLoaded === '0') {
                    return <span style={{color: '#b99f1c'}}>发布中</span>
                } else if (props.isLoaded === '2') {
                    return <span style={{color: '#ff4d4f'}}>发布失败！Git Tag不存在！</span>
                }
                
                return <span>{state.title}</span>
            }
        },
        // ...sdkAndroidAttributes
        //     .filter((column: any) => !column.hideInList)
        //     .map(mapColumn)
        //     .map(addOnCell)
        // ,
        {
            title: '操作',
            key: 'x',
            width: 140,
            render: (props: any) => {
                return (
                    <Fragment>
                        <Link to={editLink(props?.id)}>
                            <Button type="text" icon={<EditOutlined />} />
                        </Link>
                        <Link to={'/sdk_editor/android/copy/' + props?.id}>
                            <Button type="text" icon={<CopyOutlined />} />
                        </Link>
                        <ConfirmPop
                            onOk={handleDelete(props?.id)}
                            title='确认删除'
                        >
                            <Button icon={<DeleteOutlined />} type="text" danger />
                        </ConfirmPop>
                    </Fragment>
                )
            }
        },
        
    ]

    const requestDelete = useRequest(Services.androidSdk.delete)
    const handleDelete = (id: any) => () => {
        return requestDelete({sdkId: id})
            .then((res: any) => {
                message.success('删除成功')
                fetchList()
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const [dataSource, setDataSource] = React.useState<any>([])

    const requestList = useRequest(Services.androidSdk.list)
    const fetchList = () => {
        setLoading(true)
        requestList()
            .then(setDataSource)
            .finally(() => setLoading(false))
    }
    React.useEffect(() => {
        fetchList()
    }, [])

    

    const [AndroidXRadio, isAndroidX]: any = useRadioButton({
        options: [
            {label: '不限', value: ''},
            {label: 'AndroidX', value: '1'},
            {label: '非AndroidX', value: '0'},
        ]
    })

    const [PublishRadio, isPublish]: any = useRadioButton({
        options: [
            {label: '不限', value: ''},
            {label: '已发布', value: '1'},
            {label: '未发布', value: '0'},
        ]
    })

    const filterDataSource: any = pipe(
        filter((item: any) => !!~item.versionName.indexOf(version)),
        filter((item: any) => isAndroidX === '' || item?.isAndroidX.toString() === isAndroidX),
        filter((item: any) => {
            if(isPublish === '') {
                return true
            }else if(isPublish === '1') {
                return item?.enabled.toString() === '1'
            } else {
                return item?.enabled.toString() === '0'
            }
        })
    ) 

    return <div>
        <PageHeader title={title} />

        <Space align="center" style={{marginBottom: '10px'}} wrap>
            <Link to={'/sdk_editor/android'}>
                <Button type="primary">
                    添加版本
                </Button>
            </Link>

            <Input onChange={e => setVersion(e.target.value)} placeholder="SDK版本号" />

            <AndroidXRadio />
            <PublishRadio />
        </Space>
        
        <Table 
            rowKey="id"
            size="small"
            dataSource={filterDataSource(dataSource)} 
            columns={columns}
            loading={loading}
            pagination={{
                pageSize: 50
            }}
            
            expandable={{
                expandedRowRender: (record: any) => {
                    return (
                        <Fragment>
                            {
                                // [
                                //     sdkAndroidAttribute.versionDesc,
                                //     sdkAndroidAttribute.tag,
                                //     sdkAndroidAttribute.repositories,
                                //     sdkAndroidAttribute.dependencies,
                                // ]
                                sdkAndroidAttributes
                                    .filter((column: any) => !!column.hideInList)
                                    .map((column: any) => (
                                        <Fragment key={column.key}>
                                            <h3 className="m0">{column.title}</h3>
                                            {
                                                record[column.key]?.split(/\n/).map((s: any) => 
                                                    <p className="m0" key={column.key + '_'}>{s}</p>
                                                )
                                            }
                                            <br />
                                            
                                        </Fragment>
                                    ))
                            }
                        </Fragment>
                    )
                },
                rowExpandable: (record: any) => record.name !== 'Not Expandable',
            }}
        />
    </div>
})